import { CalciteLink, CalciteNotice } from '@esri/calcite-components-react';
import React from 'react';

export default function InfoPanel(): JSX.Element {
  return (
    <div className="p-4 flex gap-2 flex-col">
      <CalciteNotice
        kind="danger"
        icon="exclamation-mark-triangle"
        open
        scale="s"
      >
        <div slot="title">Use at your own risk</div>
        <div slot="message">
          This app is still in development and is not ready for production use.
        </div>
      </CalciteNotice>

      <p className="text-n1">
        Table editor allows users to query, edit, and add features to a hosted
        feature service. It is built using{' '}
        <CalciteLink
          href="https://developers.arcgis.com/arcgis-rest-js/"
          target="_blank"
        >
          ArcGIS Rest JS
        </CalciteLink>
        and React.
      </p>

      <p className="text-n1">
        Esri Employees can report any issues or feature requests on{' '}
        <CalciteLink
          href="https://github.com/EsriPS/table-editor"
          target="_blank"
        >
          GitHub
        </CalciteLink>
        .
      </p>
    </div>
  );
}
